"use client";

/*import "./FaIcon.scss";*/

const FaIcon = ({ id, href }: { id: string; href: string }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className={`fa-stack fa-lg mx-1 mx-lg-0 me-lg-2 FaIcon`}
  >
    <i className="fa fa-circle fa-stack-2x" />
    <i className={`fa ${id} fa-stack-1x fa-inverse`} />
  </a>
);

export default FaIcon;
